import Duck from 'extensible-duck';
import { createSelector } from 'reselect';

var selectors = function selectors() {
  return {
    featureFlags: new Duck.Selector(function () {
      return function (state) {
        return state === null || state === void 0 ? void 0 : state.featureFlags;
      };
    }),
    getLoading: new Duck.Selector(function () {
      return function (state) {
        return state === null || state === void 0 ? void 0 : state.featureFlags.loading;
      };
    }),
    // expecting a payload like: { flag_name: 'value', other_flag: 'value2' }
    allFeatureFlags: new Duck.Selector(function () {
      return function (state) {
        var _state$featureFlags;
        return (state === null || state === void 0 ? void 0 : (_state$featureFlags = state.featureFlags) === null || _state$featureFlags === void 0 ? void 0 : _state$featureFlags.all_flags) || {};
      };
    }),
    getFeatureFlags: new Duck.Selector(function (selectors) {
      return createSelector(selectors.featureFlags, function (_temp) {
        var _ref = _temp === void 0 ? {} : _temp,
          _ref$query_flags = _ref.query_flags,
          query_flags = _ref$query_flags === void 0 ? [] : _ref$query_flags,
          _ref$feature_flags = _ref.feature_flags,
          feature_flags = _ref$feature_flags === void 0 ? [] : _ref$feature_flags;
        return [].concat(query_flags, feature_flags);
      });
    }),
    getExperiments: new Duck.Selector(function (selectors) {
      return createSelector(selectors.allFeatureFlags, function (flags) {
        if (flags === void 0) {
          flags = {};
        }
        // converts { foo: 'bar' } to [['foo', 'bar']] for easier filtering
        var allFlags = Object.entries(flags);
        // this is ['key', 'value'] and we only care about the key
        var experimentFlags = allFlags.filter(function (_ref2) {
          var key = _ref2[0];
            _ref2[1];
          return key.startsWith('ex-');
        });
        return Object.fromEntries(experimentFlags);
      });
    }),
    getFeatureFlagIsEnabled: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (_, flag) {
        if (flag === void 0) {
          flag = '';
        }
        return flag;
      }, function (flags, flag) {
        return flags.includes(flag.toLowerCase());
      });
    }),
    newPerformanceSection: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('new-performance-section');
      });
    }),
    legacyMetrics: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('legacy-metrics');
      });
    }),
    discordIntegration: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('discord-integration');
      });
    }),
    twitterIntegration: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('twitter-integration');
      });
    }),
    youtubeIntegration: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('youtube-integration');
      });
    }),
    instagramIntegration: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('instagram-integration');
      });
    }),
    audienceChart: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('audience-chart');
      });
    }),
    iframelyRichMedia: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('iframely-rich-media');
      });
    }),
    dashboardHomepage: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('dashboard-homepage');
      });
    }),
    smsSignup: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('messaging');
      });
    }),
    conversations: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('conversations');
      });
    }),
    blasts: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('blasts');
      });
    }),
    emailOtp: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('one-time-password');
      });
    }),
    creatorBilling: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getFeatureFlags, function (flags) {
        return flags.includes('creator-billing');
      });
    })
  };
};

export { selectors as default };
//# sourceMappingURL=selectors.js.map
